import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconEmojiSerious: React.FC<IconProps> = ({ color, width = 13, height = 13 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
        >
            <g clip-path="url(#clip0_5359_16873)">
                <path
                    d="M6 0C2.68613 0 0 2.68613 0 6C0 9.31388 2.68613 12 6 12C9.31388 12 12 9.31388 12 6C12 2.68613 9.31388 0 6 0ZM6 11.625C2.89838 11.625 0.375 9.10163 0.375 6C0.375 2.89838 2.89838 0.375 6 0.375C9.10163 0.375 11.625 2.89838 11.625 6C11.625 9.10163 9.10163 11.625 6 11.625Z"
                    fill="#68C0FF"
                />
                <path
                    d="M6.57677 3.49805H2.40039V3.87305H3.32102C3.04989 4.06167 2.87177 4.37442 2.87177 4.72992C2.87177 5.30667 3.33939 5.7743 3.91614 5.7743C4.49289 5.7743 4.96052 5.30667 4.96052 4.72992C4.96052 4.3748 4.78239 4.06167 4.51127 3.87305H6.57677H6.72302H7.54839C7.27727 4.06167 7.09914 4.37442 7.09914 4.72992C7.09914 5.30667 7.56677 5.7743 8.14352 5.7743C8.72027 5.7743 9.18789 5.30667 9.18789 4.72992C9.18789 4.3748 9.00977 4.06167 8.73864 3.87305H9.60827V3.49805H6.72339H6.57677ZM3.91614 5.3993C3.54714 5.3993 3.24677 5.09892 3.24677 4.72992C3.24677 4.36092 3.54714 4.06055 3.91614 4.06055C4.28514 4.06055 4.58552 4.36092 4.58552 4.72992C4.58552 5.09892 4.28514 5.3993 3.91614 5.3993ZM8.14352 5.3993C7.77452 5.3993 7.47414 5.09892 7.47414 4.72992C7.47414 4.36092 7.77452 4.06055 8.14352 4.06055C8.51252 4.06055 8.81289 4.36092 8.81289 4.72992C8.81289 5.09892 8.51252 5.3993 8.14352 5.3993Z"
                    fill="#68C0FF"
                />
                <path
                    d="M3.66309 7.5166L3.74034 7.14948L8.34775 8.11896L8.2705 8.48609L3.66309 7.5166Z"
                    fill="#68C0FF"
                />
            </g>
            <defs>
                <clipPath id="clip0_5359_16873">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconEmojiSerious;
